function keyDeals(state = [] , action){
	return state;
}
export default keyDeals;


// WEBPACK FOOTER //
// ./src/js/reducers/keyDeals.js